/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface QuoteSummaryDto
 */
export interface QuoteSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof QuoteSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {GenericColors}
     * @memberof QuoteSummaryDto
     */
    statusColor: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    statusLabel: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    support: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof QuoteSummaryDto
     */
    contractIdentifier: IdLabel;
    /**
     * 
     * @type {IdLabel}
     * @memberof QuoteSummaryDto
     */
    quoteIdentifier: IdLabel;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    riskId?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    borrowerProjectId?: string;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof QuoteSummaryDto
     */
    insureds: Array<IdLabel>;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    branchCode: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    product: string;
    /**
     * Nom lisible du produit (complète le code `product`). Absent si null.
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    productLabel?: string | null;
    /**
     * Libellé du tunnel. Absent si null.
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    tunnelLabel?: string | null;
    /**
     * Date d'effet (ISO). Absent si null.
     * @type {Date}
     * @memberof QuoteSummaryDto
     */
    effectiveDate?: Date | null;
    /**
     * Fin de validité de l'offre (ISO). Absent si null.
     * @type {Date}
     * @memberof QuoteSummaryDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof QuoteSummaryDto
     */
    clientPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    owner: string;
    /**
     * Number of unread notifications for this quote
     * @type {number}
     * @memberof QuoteSummaryDto
     */
    unreadNotificationCount?: number;
    /**
     * Courtier propriétaire du dossier. Rempli uniquement en vue partagée (rôle Plateforme / portefeuille partagé) ; null/absent (WhenWritingNull) en vue courtier classique — sert de détecteur pour afficher la colonne « Courtier ».
     * 
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    brokerId?: string | null;
    /**
     * Nom du courtier (cf. brokerId). Renseigné en vue partagée uniquement.
     * @type {string}
     * @memberof QuoteSummaryDto
     */
    brokerName?: string | null;
}



/**
 * Check if a given object implements the QuoteSummaryDto interface.
 */
export function instanceOfQuoteSummaryDto(value: object): value is QuoteSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('support' in value) || value['support'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('quoteIdentifier' in value) || value['quoteIdentifier'] === undefined) return false;
    if (!('insureds' in value) || value['insureds'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    return true;
}

export function QuoteSummaryDtoFromJSON(json: any): QuoteSummaryDto {
    return QuoteSummaryDtoFromJSONTyped(json, false);
}

export function QuoteSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusColor': GenericColorsFromJSON(json['statusColor']),
        'statusLabel': json['statusLabel'],
        'support': json['support'],
        'contractIdentifier': IdLabelFromJSON(json['contractIdentifier']),
        'quoteIdentifier': IdLabelFromJSON(json['quoteIdentifier']),
        'riskId': json['riskId'] == null ? undefined : json['riskId'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'insureds': ((json['insureds'] as Array<any>).map(IdLabelFromJSON)),
        'branchCode': json['branchCode'],
        'product': json['product'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'tunnelLabel': json['tunnelLabel'] == null ? undefined : json['tunnelLabel'],
        'effectiveDate': json['effectiveDate'] == null ? undefined : (new Date(json['effectiveDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'clientPrice': json['clientPrice'] == null ? undefined : json['clientPrice'],
        'owner': json['owner'],
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
    };
}

export function QuoteSummaryDtoToJSON(json: any): QuoteSummaryDto {
    return QuoteSummaryDtoToJSONTyped(json, false);
}

export function QuoteSummaryDtoToJSONTyped(value?: QuoteSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'statusLabel': value['statusLabel'],
        'support': value['support'],
        'contractIdentifier': IdLabelToJSON(value['contractIdentifier']),
        'quoteIdentifier': IdLabelToJSON(value['quoteIdentifier']),
        'riskId': value['riskId'],
        'borrowerProjectId': value['borrowerProjectId'],
        'insureds': ((value['insureds'] as Array<any>).map(IdLabelToJSON)),
        'branchCode': value['branchCode'],
        'product': value['product'],
        'productLabel': value['productLabel'],
        'tunnelLabel': value['tunnelLabel'],
        'effectiveDate': value['effectiveDate'] == null ? undefined : ((value['effectiveDate'] as any).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'clientPrice': value['clientPrice'],
        'owner': value['owner'],
        'unreadNotificationCount': value['unreadNotificationCount'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
    };
}

